import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";

function TermsAndConditions() {
  const [activitydatas, setActivityDatas] = useState(null);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/get-terms")
      .then((res) => res.json())
      .then((res) => {
        // ✅ FIX: The API returns an object for 'data', not an array.
        // So we use res.data directly, not res.data[0].
        if (res.status && res.data) {
          setActivityDatas(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // Helper to handle \r\n (Windows) and \n (Unix) line breaks
  const formatHTML = (html) => {
    if (!html) return "";
    // Replaces newlines with <br /> so they render in HTML
    return html.replace(/\r?\n/g, "<br />");
  };

  // Construct full URL for SEO if slug is relative
  const getCanonicalUrl = (slug) => {
    if (!slug) return null;
    if (slug.startsWith("http")) return slug;
    return `https://planjourneysglobal.com/${slug}`;
  };

  return (
    <>
      <Helmet>
        <title>{activitydatas?.meta_title || "Terms & Conditions"}</title>
        <meta name="description" content={activitydatas?.meta_description || ""} />
        
        {activitydatas?.meta_keyword && (
          <meta name="keywords" content={activitydatas.meta_keyword} />
        )}

        {activitydatas?.slug && (
          <link rel="canonical" href={getCanonicalUrl(activitydatas.slug)} />
        )}

        {/* Open Graph */}
        <meta property="og:title" content={activitydatas?.meta_title || ""} />
        <meta property="og:description" content={activitydatas?.meta_description || ""} />
        {activitydatas?.banner_image && (
          <meta property="og:image" content={activitydatas.banner_image} />
        )}
        <meta property="og:type" content="website" />
      </Helmet>

      <Header />

      {/* Breadcrumb Banner */}
      <div
        className="breadcrumb-section"
        style={{
          backgroundImage: activitydatas?.banner_image
            ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${activitydatas.banner_image})`
            : "none",
        }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{activitydatas?.title || "Terms & Conditions"}</h1>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="about-section pt-100 mb-100 mt-30">
        <div className="container">
          {!activitydatas ? (
            <p>Loading...</p>
          ) : (
            <div
              style={{ color: "#000", lineHeight: "1.8" }}
              dangerouslySetInnerHTML={{
                __html: formatHTML(activitydatas.description),
              }}
            />
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default TermsAndConditions;